/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Gamepad_ModeInputs */



/**
* | output |
* | --- |
* | "Gamepad Mode" |
*
* @param {Options_Pedal_Gamepad_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_gamepad_mode = /** @type {((inputs?: Options_Pedal_Gamepad_ModeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Gamepad_ModeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Gamepad Mode")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gamepad Mode")
	return /** @type {LocalizedString} */ ("Gamepad Mode")
});